module.exports = __webpack_public_path__ + "static/warrior-efaca293f7b830a25de16326e45cd568.jpg";